import React, { useState, useEffect } from 'react';
import { Box, Typography, Link, IconButton, Collapse } from '@mui/material';
import { styled } from '@mui/material/styles';
import CloseIcon from '@mui/icons-material/Close';

const BannerContainer = styled(Box)(({ theme }) => ({
  width: '100%',
  backgroundColor: '#ffcc00',
  color: '#000',
  padding: '4px 0',
  textAlign: 'center',
  zIndex: 1100,
  position: 'relative'
}));

const BetaBanner = () => {
  // Initialize from sessionStorage, defaulting to true if not set
  const [visible, setVisible] = useState(() => {
    const savedState = sessionStorage.getItem('betaBannerVisible');
    return savedState === null ? true : savedState === 'true';
  });
  
  useEffect(() => {
    // Auto-hide banner after 10 seconds if it's visible
    let timer;
    if (visible) {
      timer = setTimeout(() => {
        setVisible(false);
        sessionStorage.setItem('betaBannerVisible', 'false');
      }, 10000);
    }
    
    // Clear timeout on component unmount
    return () => clearTimeout(timer);
  }, [visible]);
  
  // Update sessionStorage when visibility changes
  useEffect(() => {
    sessionStorage.setItem('betaBannerVisible', visible.toString());
  }, [visible]);
  
  const handleClose = () => {
    setVisible(false);
  };
  
  return (
    <Collapse in={visible}>
      <BannerContainer>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', position: 'relative' }}>
          <Typography variant="body2" sx={{ fontWeight: 'medium' }}>
            This is a beta version (v2). Visit <Link href="https://pimbyeli.com" target="_blank" rel="noopener noreferrer" sx={{ color: '#000', textDecoration: 'underline' }}>pimbyeli.com</Link> for the original version.
          </Typography>
          <IconButton 
            size="small" 
            onClick={handleClose}
            sx={{ 
              position: 'absolute', 
              right: 8, 
              top: '50%', 
              transform: 'translateY(-50%)',
              color: 'rgba(0, 0, 0, 0.7)',
              padding: '2px',
              '&:hover': {
                backgroundColor: 'rgba(0, 0, 0, 0.1)'
              }
            }}
            aria-label="close"
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        </Box>
      </BannerContainer>
    </Collapse>
  );
};

export default BetaBanner; 